module.exports = __webpack_public_path__ + "static/media/iconExercicesActive.db50ef16.svg";